import React, { useEffect, useState } from 'react'
import { Link, NavLink } from 'react-router-dom';
import Footer from "../components/Footer";
import main_logo from '../assets/images/UPG_site_logo.png';
import { GetPages, FilterDynamicText, getSetting } from '../API/admin'
import { Profile } from '../API/admin'
import { PhotoAPI } from '../API/player';
import Swal from "sweetalert2";
import Loader from '../views/admin/Common/Loader'
import { useSnackbar } from 'notistack'

// Css 
import "../../src/assets/PrivacyPolicy.css";

function PrivacyPolicy() {

    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [dynamicHeading, setDynamicHeading] = useState({});
    const [loginUser, setLoginUser] = useState(null)
    const [PageContent, setPageContent] = useState(null)
    let [loaderStatus, setloaderStatus] = useState(true)
    const [TournamentOff, setTouramentOff] = useState(false);


    const IMAGE_URL = process.env.REACT_APP_IMAGE_MY_ENVIRONMENT_VARIABLE;

    useEffect(() => {
        let callAPIProfile = async () => {
            let res = await Profile()
            console.log(res)
            if (res.statusCode == 403) {
                setLoginUser(null)
                setloaderStatus(false)
            } else {
                setLoginUser(res.data)
                setloaderStatus(false)
            }
        }

        let callAPI = async () => {
            let res = await GetPages('privacy_and_policy');
            console.log(res);
            if (res.status) {
                setPageContent(res.data.page_body)
            }
        }
        callAPI()
        callAPIProfile()
    }, [])
    useEffect(() => {
        let callAPI = async () => {
            let res = await getSetting()

            if (res.status) {
                res.data.map((entry, index) => {
                    if (entry.value == 'false' && entry.name === 'tournament_register') {
                        setTouramentOff(true);
                    }
                })
            } else {
                // setIsOn(null);
                enqueueSnackbar('unable to fetch setting', {
                    variant: 'error', action: (key) => (
                        <button className='toast_close_btn'
                            onClick={() => {
                                // Close the Snackbar
                                closeSnackbar(key);
                            }}
                        >
                            X
                        </button>
                    ),
                })
            }
        }
        callAPI()
    }, [])



    let PhotoReq = async () => {
        console.log("Hello")
        Swal.fire({
            title: dynamicHeading.request_photo_video
                ? dynamicHeading.request_photo_video.title
                : "Request photo/video?",
            text: dynamicHeading.request_photo_video
                ? dynamicHeading.request_photo_video.value : "Request photo/video?",
            // icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Send Request"
        }).then(async (result) => {
            if (result.isConfirmed) {
                let res = await PhotoAPI();
                if (res.data.status) {
                    if (res.data.NoMatch) {
                        enqueueSnackbar('You have not played any matches yet', {
                            variant: 'error', action: (key) => (
                                <button className='toast_close_btn'
                                    onClick={() => {
                                        // Close the Snackbar
                                        closeSnackbar(key);
                                    }}
                                >
                                    X
                                </button>
                            ),
                        })

                    } else {

                        enqueueSnackbar('Request was sent successfully', {
                            variant: 'success', action: (key) => (
                                <button className='toast_close_btn'
                                    onClick={() => {
                                        // Close the Snackbar
                                        closeSnackbar(key);
                                    }}
                                >
                                    X
                                </button>
                            ),
                        })

                    }
                } else {
                    enqueueSnackbar('Unable to send request at the moment', {
                        variant: 'error', action: (key) => (
                            <button className='toast_close_btn'
                                onClick={() => {
                                    // Close the Snackbar
                                    closeSnackbar(key);
                                }}
                            >
                                X
                            </button>
                        ),
                    })
                }

            }
        });

    }


    //    My profile navigation
    let Myprofilenavigate;
    if (loginUser) {
        switch (loginUser.role) {
            case "participant":
                Myprofilenavigate = "/participant/profile";
                break;
            case "admin":
                Myprofilenavigate = "/admin/profile";
                break;
            case "scorer":
                Myprofilenavigate = "/scorer/profile";
                break;
            default:
                Myprofilenavigate = "/";
                break;
        }
    } else {
        Myprofilenavigate = "/"; // Redirect to login if user is not logged in
    }

    return (
        <>
            {loaderStatus ? <Loader /> : null}
            <div className="main_div_heigtport">
                <header>
                    <nav className='navbar navbar-expand-lg navbar-light pt-3 pb-2 px-5 head_nav_landingpage'>
                        <a className='navbar-brand' href='/'>
                            <img src={main_logo} alt='Logo' />
                        </a>
                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#navbarNav"
                            aria-controls="navbarNav"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                            style={{ background: '#B2022F' }}
                        >
                            {/* <span className="navbar-toggler-icon" /> */}
                            <i class="bi bi-list" style={{ color: "#fff", fontSize: "25px" }}></i>
                        </button>
                        <div className='collapse navbar-collapse' id='navbarNav'>
                            <ul className='navbar-nav ms-auto'>
                                {loginUser != null ? (
                                    <>
                                        <li className='nav-item'
                                            style={{ display: (loginUser != null) ? "block" : "none" }} >
                                            <NavLink className='nav_page_btn mobile_displa_dashboard'
                                                to='/dashboard' activeClassName='active'>
                                                Dashboard
                                            </NavLink>
                                        </li>
                                        <li className='nav-item'>
                                            <a className='nav_page_btn' href='/'>
                                                Home
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a className='nav_page_btn' href='/Results'>
                                                Results
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a className='nav_page_btn' href='/photo-gallery'>
                                                Gallery
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a className='nav_page_btn' href='/contact'>
                                                Get in Touch
                                            </a>
                                        </li>
                                        <li className='nav-item dropdown'>
                                            <a
                                                className='nav-link dropdown-toggle'
                                                href='#'
                                                id='navbarDropdown'
                                                role='button'
                                                data-bs-toggle='dropdown'
                                                aria-expanded='false'
                                            >
                                                <img
                                                    src={
                                                        loginUser.profile_image !== undefined
                                                            ? IMAGE_URL + 'user/' + loginUser.profile_image
                                                            : IMAGE_URL + 'blank_user.png'
                                                    } // Replace with the actual path to the user's profile picture
                                                    alt='Profile'
                                                    className='rounded-circle'
                                                    style={{
                                                        width: "60px",
                                                        height: "60px",
                                                        objectFit: "cover",
                                                    }}
                                                />
                                            </a>
                                            <ul className="dropdown-menu dropdown-menu-end new_header_dropdown" aria-labelledby="navbarDropdown">
                                                <li className='mobile_displa_popup_dashboard'>
                                                    <Link className="dropdown-item" to="/dashboard">Dashboard</Link>
                                                </li>
                                                <li>
                                                    <NavLink className="dropdown-item" to={Myprofilenavigate}>My Profile</NavLink>
                                                </li>
                                                <li style={{ display: (loginUser.role === "participant") ? "block" : "none" }}
                                                    onClick={() => PhotoReq()}>
                                                    <Link className="dropdown-item"> Request Photo/Video</Link>
                                                </li>
                                                <li>
                                                    <Link className="dropdown-item" to="/logout">Logout</Link>
                                                </li>
                                            </ul>
                                        </li>
                                    </>
                                ) : (
                                    <>
                                    <li className='nav-item'>
                                            <a className='nav_page_btn' href='/'>
                                                Home
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a className='nav_page_btn' href='/Results'>
                                                Results
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a className='nav_page_btn' href='/photo-gallery'>
                                                Gallery
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a className='nav_page_btn' href='/contact'>
                                                Get in Touch
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            {/* Changed to NavLink */}
                                            <a className='login_btn' href='/login'>
                                                Register Now
                                            </a>

                                        </li>
                                         
                                        <li className='nav-item'>
                                            <a className='login_btn' href='/login'>
                                                Login
                                            </a>
                                        </li>
                                    </>
                                )}
                            </ul>
                        </div>
                    </nav>
                </header>
                <section className='headre_bg_div'></section>
                <div className='container-fluid pt-4 pb-5 flex-grow-1' style={{ background: "#000" }}>
                    <div className='container-lg text-white'>
                        <h3 className='all_new_pages_heading'>
                            PRIVACY POLICY
                        </h3>

                        {/* <section className='policy_content_sec'>
                        <div className='mt-5 policy_content_block '>
                            <h3 className='policy_points_head_txt'> How We Use Your Information </h3>
                            <div>
                                <b> To Provide Services: </b> To fulfill your requests, manage your account, and provide customer support.
                            </div>
                            <div>
                                <b> To Improve Our Website: </b> To analyze trends, administer the site, and track user movement.
                            </div>
                            <div>
                                <b> To Communicate with You: </b>To send updates, newsletters, marketing materials, or other information that may be of interest to you.
                            </div>
                            <div>
                                <b> For Legal Compliance:</b> To comply with legal obligations, enforce our agreements, and protect our rights.
                            </div>
                        </div>

                        <div className='mt-5 policy_content_block '>
                            <h3 className='policy_points_head_txt'> How We Share Your Information </h3>
                            <div>
                                <b> Service Providers: </b> We may share your information with trusted third-party service providers who assist us in operating our website,
                                conducting our business, or servicing you.
                            </div>
                            <div>
                                <b> Legal Requirements:</b> We may disclose your information if required by law or in response to valid requests by public authorities.
                            </div>
                        </div>

                        <div className='mt-5'>
                            <h3 className='policy_points_head_txt'> Data Security </h3>
                            <div>
                                We implement a variety of security measures to maintain the safety of your personal information. However, no method of
                                transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
                            </div>
                        </div>

                        <div className='mt-5'>
                            <h3 className='policy_points_head_txt'> What is Lorem Ipsum? </h3>
                            <div>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy
                                text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has
                                survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.
                            </div>
                        </div>

                        <div className='mt-5 pb-3'>
                            <h3 className='policy_points_head_txt'> Where does it come from? </h3>
                            <div>
                                Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC,
                                making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of
                                the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical
                                literature, discovered the undoubtable source.
                            </div>
                        </div>

                    </section> */}
                        {
                            PageContent != null ? (
                                <div>
                                    <div dangerouslySetInnerHTML={{ __html: PageContent }} />
                                </div>
                            ) :
                                <>
                                    <div className='d-flex align-items center'>
                                        <div className='nodata_row bg-dark'>
                                            No privacy policy found
                                        </div>
                                    </div>
                                </>
                        }

                    </div>
                </div>
                <Footer />
            </div>
        </>
    )
}

export default PrivacyPolicy
